/**
 * Agaru ember mark + lowercase wordmark for the TV's indigo ground.
 * Same geometry as apps/mobile/assets/brand/symbol.svg.
 */
export function AgaruLogo({ size = 72 }: { size?: number }) {
  return (
    <span className="inline-flex items-center gap-4" aria-label="Agaru">
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden>
        <g transform="translate(4 4)">
          <path d="M14.9 45.2A24 24 0 1 1 41.1 45.2" stroke="#F1EEE8" strokeWidth="5.5" strokeLinecap="round" />
          <path
            d="M28 12c5 7.5 11 12 11 20.5A11 11 0 0 1 17 32.5c0-5 2.6-8.4 5.3-11.3 1 3.3 2.8 5.3 5.2 6.3C28.4 21.8 27.5 16.8 28 12Z"
            fill="#C93A30"
          />
        </g>
      </svg>
      <span aria-hidden className="font-semibold leading-none text-[#F1EEE8]" style={{ fontFamily: '"Readex Pro", system-ui, sans-serif', fontSize: size * 0.8, letterSpacing: '-0.03em' }}>
        agaru
      </span>
    </span>
  )
}
